module.exports = __webpack_public_path__ + "static/img/OM14.be6af775.png";